import type { RouteObject } from 'react-router';
import { READABLE_OFFLINE, WORKS_OFFLINE } from '../../core/pwa/works-offline';

/**
 * One route (contracts/what-the-practitioner-sees.md "`/unsent`"). Lazy, like every other feature.
 *
 * Marked `WORKS_OFFLINE`, the same flag `help.routes.tsx` carries: this screen reads nothing but
 * the device's own outbox, so it needs no connection at all and is not what the shell's offline
 * panel exists for.
 *
 * Also marked `READABLE_OFFLINE` (036, issue 208): it is one of the two screens this cycle's slice
 * names as readable without a connection (spec brief, "Routes and the shell"). Both flags agree here
 * for different reasons — see `works-offline.ts`'s own comment on why they are not one flag.
 */
export const routes: RouteObject[] = [
  {
    index: true,
    handle: { [WORKS_OFFLINE]: true, [READABLE_OFFLINE]: true },
    lazy: async () => ({ Component: (await import('./unsent-page')).default }),
  },
];
